import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// these helpers unwrap to the `data` payload for callers.

export async function getNotifications(params = {}) {
  const res = await api.get('/notifications', { params });
  return res.data.data;
}

export async function getUnreadCount() {
  const res = await api.get('/notifications/unread-count');
  return res.data.data.unreadCount;
}

export async function getActiveBroadcasts(params = {}) {
  const res = await api.get('/notifications/broadcasts', { params });
  return res.data.data;
}

export async function markNotificationRead(id) {
  const res = await api.patch(`/notifications/${id}/read`);
  return res.data.data;
}

export async function markAllNotificationsRead() {
  await api.patch('/notifications/read-all');
}

export async function deleteNotification(id) {
  await api.delete(`/notifications/${id}`);
}
